import React from 'react';
import { Card } from 'primereact/card';
import { CombinationLogo } from '@/assets/logos/';

export interface MainCardProps {
  children: React.ReactNode;
}

const MainCard: React.FC<MainCardProps> = ({ children }) => {
  return (
    <Card className="relative border-round-2xl w-26rem max-w-full p-5">
      <CombinationLogo />
      {children}
    </Card>
  );
};

export default MainCard;
